/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */

import {Type} from "@qwoach/class-transformer-wrapper"
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseSmartFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/Smart/BaseSmartFormElement";
import ContactInfo from "@shared/Profile/ContactInfo";
import {formTriggerValidator} from "@/utils/helpers";

export default class FormElementEmergencyContacts extends BaseSmartFormElement {

	@Type(() => ContactInfo)
	answerOptions: ContactInfo[] = []
	allowAddingOptions: boolean = true
	addRelationship: boolean = true

	constructor(title, options = {}) {
		super(FormElementType.EMERGENCY_CONTACTS, title, {required: true, ...options});
	}

	resetElement() {
		super.resetElement();
		this.answerOptions = [new ContactInfo()]
		this.title = "Emergency Contacts"
		this.isRequired = true
		this.showRequiredSwitch = false
		this.placeholder = "Emergency Contacts Question Text"
		// this.disableEditing = true
		// this.specialQuestionDescription =
	}

	getSpecialQuestionDescription(){
		return "emergency contacts"
	}

	getSmartFiledPropertyName(){
		return "emergencyContacts"
	}

	getAnswer(){
		return this.answerOptions
	}

	setAnswer(answer){
		console.log("FormElementEmergencyContacts.setAnswer: ", answer)
		if(Array.isArray(answer) && answer.length > 0){
			this.answerOptions = answer
		}
	}



	getValidateRules(){
		return formTriggerValidator((value) => {
			let error

			for(let info of this.answerOptions){
				let hasFullName = !!info.fullName
				let hasInfo = !!info.contactDetails
				let hasRelationship = !!info.relationship

				let filledAtLeastOne = hasRelationship || hasInfo || hasFullName
				let notFilledAll = !hasFullName || !hasInfo || !(!this.addRelationship || hasRelationship)

				if((this.isRequired || filledAtLeastOne) && notFilledAll){
					error = "Please fill in all the fields"
					break;
				}
			}
			return error
		})
	}


}
